import React, { useState } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import moment from 'moment';
import Switch from '@material-ui/core/Switch';
import { ELEMENT } from 'constants/types';
import { ElementSmallCardWrapper } from './styles';

function ElementSmallCard(props) {
  const {
    literals, data, classesList, history,
    enableItemFromSerendipity, disableItemFromSerendipity, itemsPreferencesFromSerendipity,
  } = props;

  const [enabled, setEnabled] = useState(!_.find(itemsPreferencesFromSerendipity, item => item.element_type === ELEMENT && item.element_id === data.id && !item.enabled));

  const handleChangeEnabled = () => {
    if (!enabled) {
      enableItemFromSerendipity(ELEMENT, data.id);
    } else {
      disableItemFromSerendipity(ELEMENT, data.id);
    }

    setEnabled(!enabled);
  };

  const [timeClick, setTimeClick] = useState(null);

  const handleClick = (event) => {
    const diff = moment().valueOf() - timeClick;
    if (diff < 200 && !window.$(event.target).hasClass('MuiSwitch-input')) {
      history.push(`/elements/${data.id}`);
    }
  };

  const handleMouseDown = () => {
    setTimeClick(moment().valueOf());
  };

  const style = {};
  if (data.image) {
    style.backgroundImage = `url(${data.image})`;
  }

  let classesStr = classesList.join(' ');
  if (!enabled) {
    classesStr += ' disabled';
  }

  return (
    <ElementSmallCardWrapper className={classesStr} onClick={handleClick} onMouseDown={handleMouseDown}>
      <div className='header' style={style}>
        <div className='opacity' />
        <div className='title'>{literals[data.type] || data.type}</div>
      </div>
      <div className='body'>
        <div>{data.name}</div>
      </div>
      <div className='footer'>
        <div>
          <Switch
            checked={enabled}
            size='small'
            onChange={handleChangeEnabled}
            name='check_enabled'
            color='primary'
          />
        </div>
      </div>
    </ElementSmallCardWrapper>
  );
}

ElementSmallCard.propTypes = {
  literals: PropTypes.object.isRequired,
  data: PropTypes.object.isRequired,
  enableItemFromSerendipity: PropTypes.func.isRequired,
  disableItemFromSerendipity: PropTypes.func.isRequired,
  itemsPreferencesFromSerendipity: PropTypes.array,
  classesList: PropTypes.array,
};

ElementSmallCard.defaultProps = {
  classesList: [],
  itemsPreferencesFromSerendipity: [],
};

export default ElementSmallCard;



// WEBPACK FOOTER //
// ./src/components/Cards/ElementSmallCard/components/index.jsx